import $ from 'jquery';

export default class CartCheckbox {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          submit: '[data-cart-submit]',
        }
      },
      options
    );

    this.$el = $(el);
    this.el = this.$el.get(0);

    this.$submit = $(this.options.selectors.submit);
    this.submit = this.$submit.get(0);

    if (!!this.el && !!this.submit) {
      this.bind();
    }
  }

  bind() {
    this.el.addEventListener('change', this.handleCheck);
    this.handleCheck();
  }

  toggle() {
    window.location.reload();
  }

  toggleSubmit(enabled) {
    if (enabled) {
      this.submit.removeAttribute('disabled');
    } else {
      this.submit.setAttribute('disabled', '');
    }
  }

  handleCheck = () => {
    const checked = this.el.checked;
    this.toggleSubmit(checked);
  }

  destroy() {
    this.el.removeEventListener('change', this.handleCheck);
    this.toggleSubmit(true);
  }
}
